import { XInput, XInputValues } from '@playcastdotio/CoreTypes';
import clsx from 'clsx';

interface GamepadStateProps {
  prefix: string;
  gamepad: XInput;
  value: number;
}

export const ButtonTrigger = (props: GamepadStateProps) => {
  const { gamepad, prefix, value } = props;
  const isPressed = value === XInputValues.LEFT_TRIGGER ? gamepad.bLeftTrigger : gamepad.bRightTrigger;
  const fillColor = isPressed ? `rgba(250, 204, 21, 255)` : 'black';
  const isLeft = prefix.includes('left');

  return (
    <svg
      width='112'
      height='56'
      viewBox='0 0 112 56'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(isPressed ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '')}
    >
      <g filter='url(#filter0_d_308_19938)'>
        <rect
          id={prefix.concat('ButtonTrigger')}
          x={isLeft ? '-20' : '4'}
          width='128'
          height='48'
          rx='24'
          fill={fillColor}
          fillOpacity='0.75'
        />
        <rect x={isLeft ? '-19' : '5'} y='1' width='126' height='46' rx='23' fill='none' stroke='white' strokeOpacity='0.75' strokeWidth='2' pointerEvents='none' />
        <path
          className='pointer-events-none'
          d={
            isLeft
              ? 'M67.3246 32V14.5455H69.4382V30.125H77.5518V32H67.3246ZM77.5497 16.4205V14.5455H90.6406V16.4205H85.152V32H83.0384V16.4205H77.5497Z'
              : 'M22.2386 33V15.5455H28.1364C29.5 15.5455 30.6193 15.7784 31.4943 16.2443C32.3693 16.7045 33.017 17.3381 33.4375 18.1449C33.858 18.9517 34.0682 19.8693 34.0682 20.8977C34.0682 21.9261 33.858 22.8381 33.4375 23.6335C33.017 24.429 32.3722 25.054 31.5028 25.5085C30.6335 25.9574 29.5227 26.1818 28.1705 26.1818H23.3977V24.2727H28.1023C29.0341 24.2727 29.7841 24.1364 30.3523 23.8636C30.9261 23.5909 31.3409 23.2045 31.5966 22.7045C31.858 22.1989 31.9886 21.5966 31.9886 20.8977C31.9886 20.1989 31.858 19.5881 31.5966 19.0653C31.3352 18.5426 30.9176 18.1392 30.3438 17.8551C29.7699 17.5653 29.0114 17.4205 28.0682 17.4205H24.3523V33H22.2386ZM30.4545 25.1591L34.75 33H32.2955L28.0682 25.1591H30.4545ZM36.6357 17.4205V15.5455H49.7266V17.4205H44.2379V33H42.1243V17.4205H36.6357Z'
          }
          fill='white'
          fillOpacity='0.75'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_308_19938'
          x='-24'
          y='0'
          width='136'
          height='56'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_308_19938' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_308_19938' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

